<template>
    <div>
        <h1>Replacements</h1>

        <textarea v-model="originalText" class="form-control" rows="10"></textarea>

        <div class="form-inline mt-3">
            <div class="form-group col-sm-6">
                <label class="col-form-label col-sm-6">Child gender</label>
                <div class="col-sm-6">
                    <select v-model="childGender" class="form-control">
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                    </select>
                </div>
            </div>

            <div class="form-group col-sm-6">
                <label class="col-form-label col-sm-6">Child age</label>
                <div class="col-sm-6">
                    <select v-model="childAge" class="form-control">
                        <option v-for="n in (8 + 9)" :value="n">{{ n }}</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="form-inline mt-3">
            <div class="form-group col-sm-6">
                <label class="col-form-label col-sm-6">Adult gender</label>
                <div class="col-sm-6">
                    <select v-model="adultGender" class="form-control">
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                    </select>
                </div>
            </div>

            <div class="form-group col-sm-6">
                <label class="col-form-label col-sm-6">Adult age</label>
                <div class="col-sm-6">
                    <select v-model="adultAge" class="form-control">
                        <option v-for="n in (18 + 50)" :value="n">{{ n }}</option>
                    </select>
                </div>
            </div>
        </div>

        <p v-if="computationTime !== null">Generated in {{ computationTime }} ms</p>

        <pre v-text="replacementText" class="mt-3"></pre>
    </div>
</template>

<script>
    import {replacePersonVariables} from "@/utils/replacements/personVariables";

    export default {
        name: 'replacements',
        data() {
            return {
                computationTime: null,

                adultGender: 'male',
                adultAge: 50,

                childGender: 'female',
                childAge: 13,

                originalText: '**%CHILD_AGE%** → the age of the child\n' +
                              '**%CHILD_HE/SHE%** → "he" or "she" depending on child gender\n' +
                              '**%CHILD_HIM/HER%** → "him" or "her" depending on child gender\n' +
                              '**%CHILD_HIS/HER%** → "his" or "her" depending on child gender\n' +
                              '**%CHILD_HIS/HERS%** → "his" or "hers" depending on child gender\n' +
                              '**%CHILD_BOY/GIRLFRIEND%** → "boyfriend" or "girlfriend" depending on child gender\n' +
                              '**%CHILD_HUSBAND/WIFE%** → "husband" or "wife" depending on child gender\n' +
                              '\n' +
                              '**%ADULT_AGE%** → the age of the adult\n' +
                              '**%ADULT_HE/SHE%** → "he" or "she" depending on adult gender\n' +
                              '**%ADULT_HIM/HER%** → "him" or "her" depending on adult gender\n' +
                              '**%ADULT_HIS/HER%** → "his" or "her" depending on adult gender\n' +
                              '**%ADULT_HIS/HERS%** → "his" or "hers" depending on adult gender\n' +
                              '**%ADULT_BOY/GIRLFRIEND%** → "boyfriend" or "girlfriend" depending on adult gender\n' +
                              '**%ADULT_HUSBAND/WIFE%** → "husband" or "wife" depending on adult gender\n' +
                              '\n' +
                              'Replace "CHILD" with "ADULT" in the above codes in order to use the age/gender of the adult instead.\n' +
                              '\n' +
                              'Child-specific codes:\n' +
                              '**%BOY/GIRL%** → "boy" or "girl" depending on child gender\n' +
                              '**%SON/DAUGHTER%** → "son" or "daughter" depending on child gender\n' +
                              '**%GRANDSON/DAUGHTER%** → "grandson" or "granddaughter" depending on child gender\n' +
                              '**%NEPHEW/NIECE%** → "nephew" or "niece" depending on child gender\n' +
                              '\n' +
                              'Adult-specific codes:\n' +
                              '**%MAN/WOMAN%** → "man" or "woman" depending on child gender\n' +
                              '**%FATHER/MOTHER%** → "father" or "mother" depending on adult gender\n' +
                              '**%GRANDFATHER/MOTHER%** → "grandfather" or "grandmother" depending on adult gender\n' +
                              '**%UNCLE/AUNT%** → "uncle" or "aunt" depending on adult gender',

                replacementText: null
            };
        },
        mounted() {
            this.recomputeReplacements();
        },
        methods: {
            recomputeReplacements() {
                let start = window.performance.now();

                let child = {
                    age: this.childAge,
                    gender: this.childGender
                };

                let adult = {
                    age: this.adultAge,
                    gender: this.adultGender
                };

                let replacementText = replaceObservationVariables(this.originalText, child, adult);

                let end = window.performance.now();

                this.replacementText = replacementText;
                this.computationTime = end - start;
            }
        },
        watch: {
            originalText() {
                this.recomputeReplacements();
            },
            childAge() {
                this.recomputeReplacements();
            },
            childGender() {
                this.recomputeReplacements();
            },
            adultAge() {
                this.recomputeReplacements();
            },
            adultGender() {
                this.recomputeReplacements();
            }
        }
    }
</script>

<style lang="scss" scoped>
    pre {
        border: 1px solid #333333;
        border-radius: 5px;
        padding: 10px;
        background: #f9f9f9;
    }
</style>